import { Grid } from '@mui/material';

import FormInputLabel from './FormInputLabel';
import './FormSelectInput.css';

export default function FormSelectInput({
    label,
    name,
    handleChange,
    required = false,
    subText = '',
    helperText = '',
    options,
    optionKey,
    optionValue,
    labelSize = 6,
    inputSize = 6,
    noLabel = false,
    value = '',
    placeholder = 'Select an option',
    style,
    className,
    formData,
    disabled,
    labelStyle = {},
    showAddOption = false,
    addOptionText = '+ Add New',
    onAddOptionClick,
}) {
    return (
        <>
            {!noLabel && <FormInputLabel labelSize={labelSize} label={label} subText={subText} required={required} style={labelStyle} />}

            <Grid
                item
                xs={inputSize}
                sx={{
                    marginBottom: style?.marginBottom ? style?.marginBottom : '16px',
                }}
            >
                {/* ✅ Wrap select inside a div for proper styling */}
                <div className="custom-select-wrapper">
                    <select
                        className={`custom-select ${className} ${!value ? 'placeholder-visible' : ''}`}
                        onChange={(e) => {
                            if (showAddOption && e.target.value === '__add_new__') {
                                e.preventDefault();
                                if (onAddOptionClick) {
                                    onAddOptionClick();
                                }
                                // Reset the select to empty value
                                e.target.value = '';
                            } else {
                                handleChange(e);
                            }
                        }}
                        name={name}
                        required={required}
                        value={value || ''}
                        disabled={disabled}
                    >
                        <option value="">{placeholder}</option>
                        {showAddOption && (
                            <option 
                                value="__add_new__" 
                                style={{ 
                                    color: '#666',
                                }}
                            >
                                {addOptionText}
                            </option>
                        )}
                        {options?.map((option) => (
                            <option key={option[optionKey]} value={option[optionKey]}>
                                {optionValue
                                    .map((val) => (option[val] ? option[val].replace(/null/g, '').trim() : ''))
                                    .join(' ')}
                            </option>
                        ))}
                    </select>
                </div>
                {helperText && <span className={'help-text'} style={{marginTop: '12px', display: 'block'}} dangerouslySetInnerHTML={{__html: helperText}}></span>}
            </Grid>
        </>
    );
}
